import { withAsyncLoading } from '../../../Components/Templates/Loading/AsyncPageLoading/withAsyncPageLoading';

const LoadableControleListTodayPage = withAsyncLoading(async () =>
    import('./ControleListTodayPage').then((res) => res.ControleListTodayPage)
);

export { LoadableControleListTodayPage };
